<template>
<dataVF>
  <template slot="search">
    <div class="search-bar-container">
      <div class="tree-select-container">
        <treeselect v-model="selectedArea" :options="[area]" :normalizer="areaNormalizer" placeholder="选择区域" :flat="true" :multiple="true" noResultsText='无匹配数据' noOptionsText='无数据'></treeselect>
        <!-- <div><treeselect v-model="selectedEnergyType" :options="energyType" :normalizer="energyTypeNormalizer" placeholder="选择能源种类"></treeselect></div> -->
        <el-select v-model="selectedEnergyType"><el-option v-for="(item, index) of flatEnergyType" :key="index" :value="item.energyType" :label="item.name"></el-option></el-select>
      </div>
      <div class="spliter"></div>
      <el-select v-model="queryType" class="query-type" @change="changeQueryType">
        <!-- 只要沟通对象对术语的含义达成共识就可以。实用案例参考： 同比：vs. SPLY (Same Period Last Year) 环比：vs. LP (Last Period) -->
        <el-option label="同比" value="sply"></el-option>
        <el-option label="环比" value="lp"></el-option>
      </el-select>
      <YMDATimeRangeSelect v-model="date" :queryType="queryType" :disableAny="true"></YMDATimeRangeSelect>
      <div>
        <el-button type="primary" @click="getTSDBData" :disabled="queryUsable">查询</el-button>
        <el-button type="warning" @click="exportData">导出</el-button>
      </div>
    </div>
  </template>
  <template slot="charts">
    <el-card>
      <chart ref="charts1" :options="charts1Option" ></chart>
    </el-card>
  </template>
  <template slot="table">
    <el-card>
      <QueryTable :queryData="tableData" :deviceList="assetIds" :date="date" ref="elTable" :queryType="queryType" :unit="unit"></QueryTable>
    </el-card>
  </template>
</dataVF>
</template>

<script>
// import dataVF from '@/views/layout/dataVisualizationFrame'
// import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import YMDATimeRangeSelect from './components/YMDAtimeRangeSelect.vue'
import { queryAssetData } from '@/api/tsdb-controller'
import QueryTable from './components/table.vue'
import _ from 'lodash'
import { baseMixin } from '@/views/layout/dataVisualizationFrame/components/baseMixIn.js'
import { removeSlash } from '@/utils/removeIdSlash.js'
const moment = require('moment') // 处理id

export default {
  name: 'energyConsumptionTrend',
  mixins: [
    baseMixin
  ],
  components: {
    // dataVF
    // Treeselect
    YMDATimeRangeSelect,
    QueryTable
  },
  // props: ['area', 'energyType'],
  props: ['enertyCatgoryTextMap', 'energyTextMap'],
  data() {
    return {
      unit: '',
      queryType: 'sply',
      tableData: [],
      assetIds: [],
      charts1Option: {
        title: {
          text: '同比环比',
          textStyle: {
            color: '#333'
          }
        },
        textStyle: {
          color: '#333333'
        },
        grid: {
          left: '0px',
          right: '30px',
          top: '45px',
          bottom: '30px',
          backgroundColor: 'transparent',
          // show: true,
          containLabel: true
        },
        color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          },
          confine: true,
          formatter: (params) => {
            return params.map(p => {
              return '<div style="display: inline-block;border-radius: 100px; width: 10px; height: 10px; background-color: ' + p.color + ';' + '"></div>' + p.seriesName + ': ' + p.data + '% ' + '<br />'
            }).join('')
          }
        },
        legend: {
          type: 'scroll',
          data: [],
          left: 90,
          right: 40,
          textStyle: {
            color: '#333'
          }
        },
        xAxis: {
          data: [],
          boundaryGap: false,
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#333'
            }
          }
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              color: '#ccc'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#333'
            }
          }
        },
        series: []
      }
    }
  },
  methods: {
    changeQueryType() {
      if (this.date[0] === 'month') {
        // pass
        // this.date = ['month', [moment().startOf('month').valueOf(), moment().endOf('month').add(1, 'ms').valueOf()]]
      } else {
        this.date = ['month', [moment().startOf('month').valueOf(), moment().endOf('month').add(1, 'ms').valueOf()]]
      }
    },
    getTSDBData() {
      this.queryUsable = true
      setTimeout(() => {
        this.queryUsable = false
      }, 5000)
      if (this.$refs.charts1) {
        this.$refs.charts1.clear()
      }
      this.charts1Option.series = []
      this.charts1Option.xAxis.data = []
      this.charts1Option.legend.data = []
      this.tableData = []
      const pId = this.$store.state.app.project.id.id
      if (this.queryType === 'sply') {
        const lastYearQueryData = Object.assign({}, this.queryData)
        lastYearQueryData.start = new Date(this.queryData.start).setFullYear(new Date(this.queryData.start).getFullYear() - 1)
        lastYearQueryData.end = new Date(this.queryData.end).setFullYear(new Date(this.queryData.end).getFullYear() - 1)
        const lastYearPromise = queryAssetData(lastYearQueryData, removeSlash(pId))
        const thisYearPromise = queryAssetData(this.queryData, removeSlash(pId))
        Promise.all([lastYearPromise, thisYearPromise]).then(res => {
          this.splyPostProcess([res[0].data, res[1].data])
          // const tData = [res[0].data, res[1].data]
          // if (this.queryData.attribute === 'energyAll') {
          //   for (const d of tData) {
          //     for (const item in d) {
          //       for (const v in d[item]) {
          //         d[item][v] = d[item][v].value
          //       }
          //     }
          //   }
          // }
          // this.splyPostProcess(tData)
        })
      } else {
        // pass
        const lpQueryData = Object.assign({}, this.queryData)
        switch (lpQueryData.type) {
          case 'year':
            lpQueryData.start = moment(this.queryData.start).subtract(1, 'months').startOf('year').valueOf()
            lpQueryData.end = moment(this.queryData.end).valueOf()
            break
          case 'month':
            lpQueryData.start = moment(this.queryData.start).subtract(1, 'days').startOf('month').valueOf()
            lpQueryData.end = moment(this.queryData.end).subtract(1, 'months').endOf('months').valueOf() + 1
            break
          case 'day':
            lpQueryData.start = moment(this.queryData.start).subtract(1, 'days').valueOf()
            break
          default:
            break
        }
        queryAssetData(lpQueryData, removeSlash(pId)).then(res => {
          this.lpPostProcess(res.data)
          // const tData = res.data
          // if (this.queryData.attribute === 'energyAll') {
          //   for (const item in tData) {
          //     for (const v in tData[item]) {
          //       tData[item][v] = tData[item][v].value
          //     }
          //   }
          // }
          // this.lpPostProcess(tData)
        })
      }
    },
    // 环比
    lpPostProcess(data) {
      // get Assets
      this.assetIds = _.keys(data)

      // push legend
      for (const item of this.assetIds) {
        this.charts1Option.legend.data.push(this.assetList.get(item))
      }

      // push xAxis
      let xAxisData = _.keys(_.values(data)[0])
      switch (this.date[0]) {
        case 'day':
          xAxisData = xAxisData.map(d => d.substring(5))
          break
        default:
          break
      }
      xAxisData.shift()
      this.charts1Option.xAxis.data = xAxisData

      // push data
      // let values = _.values(_.values(data)[0])
      // values = values.map((val, i) => {
      //   if (values[i + 1]) {
      //     return values[i] / values[i + 1]
      //   }
      // })
      // values.pup()
      for (const item of this.assetIds) {
        const serie = {
          name: this.assetList.get(item),
          type: 'line',
          data: []
        }
        let values = _.values(data[item])
        values = values.map((val, i) => {
          if (values[i + 1]) {
            const val = (values[i + 1] - values[i]) / values[i]
            return this.ndwnai(val * 100)
          }
        })
        values.pop()
        serie.data = values
        this.charts1Option.series.push(serie)
      }

      // generate table data
      for (const [index, date] of _.keys(_.values(data)[0]).entries()) {
        for (const deviceId in data) {
          let past = this.dwnai(_.values(data[deviceId])[index - 1])
          let now = this.dwnai(_.values(data[deviceId])[index])
          const unit = ' ' + this.energyTextMap.get(this.selectedEnergyType)
          this.unit = unit
          const rate = (_.values(data[deviceId])[index] - _.values(data[deviceId])[index - 1]) / _.values(data[deviceId])[index - 1]
          if (past === '0.00') {
            past = '-'
          }
          if (now === '0.00') {
            now = '-'
          }
          const row = {
            date: date,
            asset: this.assetList.get(deviceId),
            past: past,
            now: now,
            // unit: this.energyTextMap.get(this.selectedEnergyType),
            // rate: 0 + ' %'
            rate: this.ndwnai(rate * 100) + ' %'
          }
          // row.rate = (_.values(data[deviceId])[index] !== null) && (_.values(data[deviceId])[index - 1] !== null) ? this.dwnai(((_.values(data[deviceId])[index] - _.values(data[deviceId])[index - 1]) / _.values(data[deviceId])[index - 1]) * 100) + ' %' : '- %'
          this.tableData.push(row)
        }
      }
      _.keys(data).map(id => {
        this.tableData.shift()
      })
      if (this.tableData.length === 0) {
        this.charts1Option.series = []
        this.charts1Option.xAxis.data = []
        this.charts1Option.legend.data = []
        this.$message('无数据')
      }
      setTimeout(() => {
        this.queryUsable = false
      }, 1000)
    },
    // 同比
    splyPostProcess(data) {
      // get Assets

      // 其中一年没有值得时候 对应赋值
      if (!this.ifObject(data[0]) && this.ifObject(data[1])) {
        for (const item in data[1]) {
          data[0][item] = {}
          for (const i in data[1][item]) {
            data[0][item][i] = 0
          }
        }
      }
      if (!this.ifObject(data[1]) && this.ifObject(data[0])) {
        for (const item in data[0]) {
          data[1][item] = {}
          for (const i in data[0][item]) {
            data[1][item][i] = 0
          }
        }
      }
      this.assetIds = _.keys(data[0])

      // push legend

      for (const item of this.assetIds) {
        this.charts1Option.legend.data.push(this.assetList.get(item))
      }
      // push xAxis
      for (const item of _.keys(_.values(data[1])[0])) {
        // this.charts1Option.xAxis.data.push(item)
        switch (this.date[0]) {
          case 'day':
            this.charts1Option.xAxis.data.push(item.substring(5))
            break
          default:
            this.charts1Option.xAxis.data.push(item)
            break
        }
      }
      // push data to echarts

      for (const item of this.assetIds) {
        const tdata = _.values(data[0][item]).map((val, i) => {
          const tValue = (_.values(data[1][item])[i] - val) / val
          return this.ndwnai(tValue * 100)
        })
        const serie = {
          name: this.assetList.get(item),
          type: 'line',
          data: tdata
        }
        this.charts1Option.series.push(serie)
      }

      for (const [index, date] of _.keys(_.values(data[1])[0]).entries()) {
        for (const deviceId in data[0]) {
          let past = this.dwnai(_.values(data[0][deviceId])[index])
          let now = this.dwnai(data[1][deviceId][date])
          const unit = ' ' + this.energyTextMap.get(this.selectedEnergyType)
          this.unit = unit
          const rate = (data[1][deviceId][date] - _.values(data[0][deviceId])[index]) / _.values(data[0][deviceId])[index]
          if (past === '0.00') {
            past = '-'
          }
          if (now === '0.00') {
            now = '-'
          }
          const row = {
            date: date,
            asset: this.assetList.get(deviceId),
            past: past,
            now: now,
            // unit: this.energyTextMap.get(this.selectedEnergyType),
            rate: this.ndwnai(rate * 100) + ' %'
          }
          this.tableData.push(row)
        }
      }
      if (this.tableData.length === 0) {
        this.charts1Option.series = []
        this.charts1Option.xAxis.data = []
        this.charts1Option.legend.data = []
        this.$message('无数据')
      }
      setTimeout(() => {
        this.queryUsable = false
      }, 1000)
    },
    ifObject(item) {
      for (const i in item) {
        return true
      }
      return false
    }
  },
  created() {
    this.selectedArea = []
    this.selectedArea[0] = this.area.assetId
    // 主题部分
    if (this.themeDark) {
      this.charts1Option.textStyle.color = '#BCC3DF'
      this.charts1Option.title.textStyle.color = '#ffffff'
      this.charts1Option.legend.textStyle.color = '#ffffff'
      this.charts1Option.yAxis.splitLine.lineStyle.color = '#303958'
      this.charts1Option.yAxis.axisLine.lineStyle.color = '#354eb1'
      this.charts1Option.xAxis.axisLine.lineStyle.color = '#354eb1'
      this.charts1Option.color = ['#70f3ff', '#bb8fa9', '#b7fbff', '#82acff', '#fff4e3', '#fb767b', '#fff8cd', '#ffaaaa', '#ff5da2', '#f2c0ff', '#bf9fee']
    }
    this.getTSDBData()
  },
  mounted() {
  },
  computed: {
    timeReslution() {
      switch (this.date[0]) {
        case 'year':
          return 'year'
        case 'month':
          return 'month'
        case 'day':
          return 'day'
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-bar-container {
  display: flex;
  align-items: flex-start;
  .spliter {
    flex: auto;
  }
}
.table-container {
  overflow: scroll;
}
.tree-select-container {
  display: flex;
}
.vue-treeselect{
  width: 200px;
  margin: 5px;
  // height: 40px;
}

.el-card ::v-deep {
  width: 100%;
  height: 435px;
  .el-card__body {
    height: 100%;
  }
  .echarts {
    width: 100%;
    height: 100%;
  }
}
.query-type{
  width: 80px;
  margin-right: 5px;
}
</style>
